import {
  B000111DenpyoshubetsuNm,
  B000111TenpudenpyoNm,
  B000111TokuibunNm1,
  B000111TokuibunNm2,
  B000111TokuibunNm3,
  B000111TokuibunNm4,
  B000111TokuibunNm5,
  B000111UnsogaishaNm,
  B000130BumonNm,
  B000130UrikakebumonNm,
  B000140ShainNmBumonCd,
  B000140UrikakeshainNmBumonCd,
  B000190ItakusokoNmr,
  catchRestError,
  RestClient,
} from "clients/rest";
import {
  B100060Tankahasuichi,
  B100ShokaKbn,
  getSCode,
  JodaihyojiKbn,
  KaishuKbn,
  KaishuyoteiM,
  KinmaremeKbn,
  KyakusakinoKbn,
  NonyuKbn,
  SakujoyoteiKbn,
  SeikyuKbn,
  SeikyushoKbn,
  SeikyushokeishikiKbn,
  SeikyushosaibanKbn,
  ShokuchiKbn,
  ShutsuryokushohinCd,
  TankamarumeKbn,
  TokuiKbn,
  UrikakeKbn,
  ZeiKbn,
  ZeimarumeKbn,
} from "messages/codes";
import { UseFormReturn } from "react-hook-form";

export type B100060CreateRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm1: string;
  tokuiNmr: string;
  shokuchiKbn: string;
  shokaKbn: string;
  tokuiKbn: string;
  seikyuKbn: string;
  seikyuCd: string;
  seikyushitenCd: string;
  urikakeKbn: string;
  urikakeCd: string;
  urikakeshitenCd: string;
  nonyuKbn: string;
  urikakeshainCd: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  kinmarumeKbn: string;
  zeimarumeKbn: string;
  zeihasuichi: string;
  zeiKbn: string;
  tankamarumeKbn: string;
  tankahasuichiKbn: string;
  tankahasuichi: string;
  tankaKakeritsu: string;
  jodaihyojiKbn: string;
  sakujoyoteiKbn: string;
} & Partial<{
  tokuiNm2: string;
  tokuiKana: string;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  itakusokoCd: string;
  unsogaishaCd: string;
  shainCd: string;
  shimeD: string;
  kaishuyoteiM: string;
  kaishuyoteiD: string;
  kaishuKbn: string;
  seikyushoKbn: string;
  seikyushokeishikiKbn: string;
  seikyushosaibanKbn: string;
  seikyushoNo: string;
  denpyogyosu: string;
  denpyoshubetsuCd: string;
  denpyoKbn: string;
  tenpudenpyoCd: string;
  ritsu: string;
  bunrui: string;
  shutsuryokushohinCd: string;
  torihikisakiCd: string;
  hyakatenCd: string;
  shatenCd: string;
  kyakusakinoKbn: string;
  kigyoCd: string;
  tenpoCd: string;
  tokuibunCd1: string;
  tokuibunCd2: string;
  tokuibunCd3: string;
  tokuibunCd4: string;
  tokuibunCd5: string;
}>;

//新規登録処理
export const B100060Create = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100060CreateRequest = {
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    tokuiNm1: fields.tokuiNm1,
    tokuiNm2: fields.tokuiNm2,
    tokuiKana: fields.tokuiKana,
    tokuiNmr: fields.tokuiNmr,
    shokuchiKbn: fields.shokuchiKbn.value,
    postCd: fields.postCd,
    address1: fields.address1,
    address2: fields.address2,
    telNo: fields.telNo,
    faxNo: fields.faxNo,
    shokaKbn: fields.shokaKbn.value,
    itakusokoCd: fields.itakusokoCd,
    tokuiKbn: fields.tokuiKbn.value,
    seikyuKbn: fields.seikyuKbn.value,
    seikyuCd: fields.seikyuCd,
    seikyushitenCd: fields.seikyushitenCd,
    urikakeKbn: fields.urikakeKbn.value,
    urikakeCd: fields.urikakeCd,
    urikakeshitenCd: fields.urikakeshitenCd,
    nonyuKbn: fields.nonyuKbn.value,
    unsogaishaCd: fields.unsogaishaCd,
    shainCd: fields.shainCd,
    urikakeshainCd: fields.urikakeshainCd,
    torihikikaishiYmd: fields.torihikikaishiYmd,
    torihikishuryoYmd: fields.torihikishuryoYmd,
    shimeD: fields.shimeD,
    kaishuyoteiM: fields.kaishuyoteiM.value,
    kaishuyoteiD: fields.kaishuyoteiD,
    kaishuKbn: fields.kaishuKbn.value,
    seikyushoKbn: fields.seikyushoKbn.value,
    seikyushokeishikiKbn: fields.seikyushokeishikiKbn.value,
    seikyushosaibanKbn: fields.seikyushosaibanKbn.value,
    seikyushoNo: fields.seikyushoNo,
    denpyogyosu: fields.denpyogyosu,
    denpyoshubetsuCd: fields.denpyoshubetsuCd,
    denpyoKbn: fields.denpyoKbn,
    tenpudenpyoCd: fields.tenpudenpyoCd,
    ritsu: fields.ritsu,
    bunrui: fields.bunrui,
    shutsuryokushohinCd: fields.shutsuryokushohinCd.value,
    torihikisakiCd: fields.torihikisakiCd,
    hyakatenCd: fields.hyakatenCd,
    shatenCd: fields.shatenCd,
    kinmarumeKbn: fields.kinmarumeKbn.value,
    zeimarumeKbn: fields.zeimarumeKbn.value,
    zeihasuichi: fields.zeihasuichi,
    zeiKbn: fields.zeiKbn.value,
    tankamarumeKbn: fields.tankamarumeKbn.value,
    tankahasuichiKbn: fields.tankahasuichiKbn.value,
    tankahasuichi: fields.tankahasuichi,
    tankaKakeritsu: fields.tankaKakeritsu,
    jodaihyojiKbn: fields.jodaihyojiKbn.value,
    sakujoyoteiKbn: fields.sakujoyoteiKbn.value,
    kyakusakinoKbn: fields.kyakusakinoKbn.value,
    kigyoCd: fields.kigyoCd,
    tenpoCd: fields.tenpoCd,
    tokuibunCd1: fields.tokuibunCd1,
    tokuibunCd2: fields.tokuibunCd2,
    tokuibunCd3: fields.tokuibunCd3,
    tokuibunCd4: fields.tokuibunCd4,
    tokuibunCd5: fields.tokuibunCd5,
  };

  return RestClient.post("b100060/create", data);
};

export type B100060UpdateRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm1: string;
  tokuiNmr: string;
  shokuchiKbn: string;
  shokaKbn: string;
  tokuiKbn: string;
  seikyuKbn: string;
  urikakeKbn: string;
  nonyuKbn: string;
  urikakeshainCd: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  kinmarumeKbn: string;
  zeimarumeKbn: string;
  zeihasuichi: string;
  zeiKbn: string;
  tankamarumeKbn: string;
  tankahasuichiKbn: string;
  tankahasuichi: string;
  tankaKakeritsu: string;
  jodaihyojiKbn: string;
  sakujoyoteiKbn: string;
} & Partial<{
  tokuiNm2: string;
  tokuiKana: string;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  itakusokoCd: string;
  seikyuCd: string;
  seikyushitenCd: string;
  urikakeCd: string;
  urikakeshitenCd: string;
  unsogaishaCd: string;
  shainCd: string;
  shimeD: string;
  kaishuyoteiM: string;
  kaishuyoteiD: string;
  kaishuKbn: string;
  seikyushoKbn: string;
  seikyushokeishikiKbn: string;
  seikyushosaibanKbn: string;
  seikyushoNo: string;
  denpyogyosu: string;
  denpyoshubetsuCd: string;
  denpyoKbn: string;
  tenpudenpyoCd: string;
  ritsu: string;
  bunrui: string;
  shutsuryokushohinCd: string;
  torihikisakiCd: string;
  hyakatenCd: string;
  shatenCd: string;
  kyakusakinoKbn: string;
  kigyoCd: string;
  tenpoCd: string;
  tokuibunCd1: string;
  tokuibunCd2: string;
  tokuibunCd3: string;
  tokuibunCd4: string;
  tokuibunCd5: string;
  version: string;
}>;

export const B100060Update = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100060UpdateRequest = {
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    tokuiNm1: fields.tokuiNm1,
    tokuiNm2: fields.tokuiNm2,
    tokuiKana: fields.tokuiKana,
    tokuiNmr: fields.tokuiNmr,
    shokuchiKbn: fields.shokuchiKbn.value,
    postCd: fields.postCd,
    address1: fields.address1,
    address2: fields.address2,
    telNo: fields.telNo,
    faxNo: fields.faxNo,
    shokaKbn: fields.shokaKbn.value,
    itakusokoCd: fields.itakusokoCd,
    tokuiKbn: fields.tokuiKbn.value,
    seikyuKbn: fields.seikyuKbn.value,
    seikyuCd: fields.seikyuCd,
    seikyushitenCd: fields.seikyushitenCd,
    urikakeKbn: fields.urikakeKbn.value,
    urikakeCd: fields.urikakeCd,
    urikakeshitenCd: fields.urikakeshitenCd,
    nonyuKbn: fields.nonyuKbn.value,
    unsogaishaCd: fields.unsogaishaCd,
    shainCd: fields.shainCd,
    urikakeshainCd: fields.urikakeshainCd,
    torihikikaishiYmd: fields.torihikikaishiYmd,
    torihikishuryoYmd: fields.torihikishuryoYmd,
    shimeD: fields.shimeD,
    kaishuyoteiM: fields.kaishuyoteiM.value,
    kaishuyoteiD: fields.kaishuyoteiD,
    kaishuKbn: fields.kaishuKbn.value,
    seikyushoKbn: fields.seikyushoKbn.value,
    seikyushokeishikiKbn: fields.seikyushokeishikiKbn.value,
    seikyushosaibanKbn: fields.seikyushosaibanKbn.value,
    seikyushoNo: fields.seikyushoNo,
    denpyogyosu: fields.denpyogyosu,
    denpyoshubetsuCd: fields.denpyoshubetsuCd,
    denpyoKbn: fields.denpyoKbn,
    tenpudenpyoCd: fields.tenpudenpyoCd,
    ritsu: fields.ritsu,
    bunrui: fields.bunrui,
    shutsuryokushohinCd: fields.shutsuryokushohinCd.value,
    torihikisakiCd: fields.torihikisakiCd,
    hyakatenCd: fields.hyakatenCd,
    shatenCd: fields.shatenCd,
    kinmarumeKbn: fields.kinmarumeKbn.value,
    zeimarumeKbn: fields.zeimarumeKbn.value,
    zeihasuichi: fields.zeihasuichi,
    zeiKbn: fields.zeiKbn.value,
    tankamarumeKbn: fields.tankamarumeKbn.value,
    tankahasuichiKbn: fields.tankahasuichiKbn.value,
    tankahasuichi: fields.tankahasuichi,
    tankaKakeritsu: fields.tankaKakeritsu,
    jodaihyojiKbn: fields.jodaihyojiKbn.value,
    sakujoyoteiKbn: fields.sakujoyoteiKbn.value,
    kyakusakinoKbn: fields.kyakusakinoKbn.value,
    kigyoCd: fields.kigyoCd,
    tenpoCd: fields.tenpoCd,
    tokuibunCd1: fields.tokuibunCd1,
    tokuibunCd2: fields.tokuibunCd2,
    tokuibunCd3: fields.tokuibunCd3,
    tokuibunCd4: fields.tokuibunCd4,
    tokuibunCd5: fields.tokuibunCd5,
    version: fields.version,
  };

  return RestClient.put("b100060/update", data);
};

export type B100060GetRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
} & Partial<{}>;

export const B100060Get = (props: B100060GetRequest) => {
  return RestClient.get("b100060/get", {
    params: props,
  });
};

// 得意先情報表示処理
export const B100060Tokui = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCd === "" || data.tokuishitenCd === "") {
    methods.setValue("tokuiNm1", "");
    methods.setValue("tokuiNm2", "");
    methods.setValue("tokuiKana", "");
    methods.setValue("tokuiNmr", "");
    methods.setValue("shokuchiKbn", null);
    methods.setValue("postCd", "");
    methods.setValue("address1", "");
    methods.setValue("address2", "");
    methods.setValue("telNo", "");
    methods.setValue("faxNo", "");
    methods.setValue("shokaKbn", null);
    methods.setValue("itakusokoCd", "");
    methods.setValue("sokoNm", "");
    methods.setValue("tokuiKbn", null);
    methods.setValue("seikyuKbn", null);
    methods.setValue("seikyuCd", "");
    methods.setValue("seikyushitenCd", "");
    methods.setValue("urikakeKbn", null);
    methods.setValue("urikakeCd", "");
    methods.setValue("urikakeshitenCd", "");
    methods.setValue("nonyuKbn", null);
    methods.setValue("unsogaishaCd", "");
    methods.setValue("unsogaishaNm", "");
    methods.setValue("shainCd", "");
    methods.setValue("shainNm", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("urikakeshainCd", "");
    methods.setValue("urikakeshainNm", "");
    methods.setValue("urikakebumonCd", "");
    methods.setValue("urikakebumonNm", "");
    methods.setValue("torihikikaishiYmd", "");
    methods.setValue("torihikishuryoYmd", "");
    methods.setValue("shimeD", "");
    methods.setValue("kaishuyoteiM", null);
    methods.setValue("kaishuyoteiD", "");
    methods.setValue("kaishuKbn", "");
    methods.setValue("seikyushoKbn", null);
    methods.setValue("seikyushokeishikiKbn", null);
    methods.setValue("seikyushosaibanKbn", null);
    methods.setValue("seikyushoNo", null);
    methods.setValue("denpyogyosu", "");
    methods.setValue("denpyoshubetsuCd", "");
    methods.setValue("denpyoshubetsuNm", "");
    methods.setValue("denpyoKbn", "");
    methods.setValue("tenpudenpyoCd", "");
    methods.setValue("tenpudenpyoNm", "");
    methods.setValue("ritsu", "");
    methods.setValue("bunrui", "");
    methods.setValue("shutsuryokushohinCd", null);
    methods.setValue("torihikisakiCd", "");
    methods.setValue("hyakatenCd", "");
    methods.setValue("shatenCd", "");
    methods.setValue("kinmarumeKbn", null);
    methods.setValue("zeimarumeKbn", null);
    methods.setValue("zeiKbn", null);
    methods.setValue("tankamarumeKbn", null);
    methods.setValue("tankahasuichiKbn", null);
    methods.setValue("tankahasuichi", "");
    methods.setValue("tankaKakeritsu", "");
    methods.setValue("jodaihyojiKbn", null);
    methods.setValue("sakujoyoteiKbn", null);
    methods.setValue("kyakusakinoKbn", null);
    methods.setValue("kigyoCd", "");
    methods.setValue("tenpoCd", "");
    methods.setValue("tokuibunCd1", "");
    methods.setValue("tokuibunNm1", "");
    methods.setValue("tokuibunCd2", "");
    methods.setValue("tokuibunNm2", "");
    methods.setValue("tokuibunCd3", "");
    methods.setValue("tokuibunNm3", "");
    methods.setValue("tokuibunCd4", "");
    methods.setValue("tokuibunNm4", "");
    methods.setValue("tokuibunCd5", "");
    methods.setValue("tokuibunNm5", "");
    methods.setValue("version", "");
    return;
  }
  await B100060Get({
    tokuiCd: data.tokuiCd,
    tokuishitenCd: data.tokuishitenCd,
  })
    .then((response) => {
      methods.setValue("tokuiNm1", response.data.tokuiNm1 ?? "");
      methods.setValue("tokuiNm2", response.data.tokuiNm2 ?? "");
      methods.setValue("tokuiKana", response.data.tokuiKana ?? "");
      methods.setValue("tokuiNmr", response.data.tokuiNmr ?? "");
      methods.setValue(
        "shokuchiKbn",
        getSCode(ShokuchiKbn, response.data.shokuchiKbn) ?? null
      );
      methods.setValue("postCd", response.data.postCd ?? "");
      methods.setValue("address1", response.data.address1 ?? "");
      methods.setValue("address2", response.data.address2 ?? "");
      methods.setValue("telNo", response.data.telNo ?? "");
      methods.setValue("faxNo", response.data.faxNo ?? "");
      methods.setValue(
        "shokaKbn",
        getSCode(B100ShokaKbn, response.data.shokaKbn) ?? null
      );
      methods.setValue("itakusokoCd", response.data.itakusokoCd ?? "");
      methods.setValue(
        "tokuiKbn",
        getSCode(TokuiKbn, response.data.tokuiKbn) ?? null
      );
      methods.setValue(
        "seikyuKbn",
        getSCode(SeikyuKbn, response.data.seikyuKbn) ?? null
      );
      methods.setValue("seikyuCd", response.data.seikyuCd ?? "");
      methods.setValue("seikyushitenCd", response.data.seikyushitenCd ?? "");
      methods.setValue(
        "urikakeKbn",
        getSCode(UrikakeKbn, response.data.urikakeKbn) ?? null
      );
      methods.setValue("urikakeCd", response.data.urikakeCd ?? "");
      methods.setValue("urikakeshitenCd", response.data.urikakeshitenCd ?? "");
      methods.setValue(
        "nonyuKbn",
        getSCode(NonyuKbn, response.data.nonyuKbn) ?? null
      );
      methods.setValue("unsogaishaCd", response.data.unsogaishaCd ?? "");
      methods.setValue("shainCd", response.data.shainCd ?? "");
      methods.setValue("urikakeshainCd", response.data.urikakeshainCd ?? "");
      methods.setValue(
        "torihikikaishiYmd",
        response.data.torihikikaishiYmd ?? ""
      );
      methods.setValue(
        "torihikishuryoYmd",
        response.data.torihikishuryoYmd ?? ""
      );
      methods.setValue("shimeD", response.data.shimeD ?? "");
      methods.setValue(
        "kaishuyoteiM",
        getSCode(KaishuyoteiM, response.data.kaishuyoteiM) ?? null
      );
      methods.setValue("kaishuyoteiD", response.data.kaishuyoteiD ?? "");
      methods.setValue(
        "kaishuKbn",
        getSCode(KaishuKbn, response.data.kaishuKbn) ?? null
      );
      methods.setValue(
        "seikyushoKbn",
        getSCode(SeikyushoKbn, response.data.seikyushoKbn) ?? null
      );
      methods.setValue(
        "seikyushokeishikiKbn",
        getSCode(SeikyushokeishikiKbn, response.data.seikyushokeishikiKbn) ??
          null
      );
      methods.setValue(
        "seikyushosaibanKbn",
        getSCode(SeikyushosaibanKbn, response.data.seikyushosaibanKbn) ?? null
      );
      methods.setValue("seikyushoNo", response.data.seikyushoNo ?? "");
      methods.setValue("denpyogyosu", response.data.denpyogyosu ?? "");
      methods.setValue(
        "denpyoshubetsuCd",
        response.data.denpyoshubetsuCd ?? ""
      );
      methods.setValue("denpyoKbn", response.data.denpyoKbn ?? "");
      methods.setValue("tenpudenpyoCd", response.data.tenpudenpyoCd ?? "");
      methods.setValue("ritsu", response.data.ritsu ?? "");
      methods.setValue("bunrui", response.data.bunrui ?? "");
      methods.setValue(
        "shutsuryokushohinCd",
        getSCode(ShutsuryokushohinCd, response.data.shutsuryokushohinCd) ?? null
      );
      methods.setValue("torihikisakiCd", response.data.torihikisakiCd ?? "");
      methods.setValue("hyakatenCd", response.data.hyakatenCd ?? "");
      methods.setValue("shatenCd", response.data.shatenCd ?? "");
      methods.setValue(
        "kinmarumeKbn",
        getSCode(KinmaremeKbn, response.data.kinmarumeKbn) ?? null
      );
      methods.setValue(
        "zeimarumeKbn",
        getSCode(ZeimarumeKbn, response.data.zeimarumeKbn) ?? null
      );
      methods.setValue(
        "zeiKbn",
        getSCode(ZeiKbn, response.data.zeiKbn) ?? null
      );
      methods.setValue(
        "tankamarumeKbn",
        getSCode(TankamarumeKbn, response.data.tankamarumeKbn) ?? null
      );
      methods.setValue(
        "tankahasuichiKbn",
        getSCode(TankamarumeKbn, response.data.tankahasuichiKbn) ?? null
      );
      methods.setValue("tankahasuichi", response.data.tankahasuichi ?? "");
      methods.setValue("tankaKakeritsu", response.data.tankaKakeritsu ?? "");
      methods.setValue(
        "jodaihyojiKbn",
        getSCode(JodaihyojiKbn, response.data.jodaihyojiKbn) ?? null
      );
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn) ?? null
      );
      methods.setValue(
        "kyakusakinoKbn",
        getSCode(KyakusakinoKbn, response.data.kyakusakinoKbn) ?? null
      );
      methods.setValue("kigyoCd", response.data.kigyoCd ?? "");
      methods.setValue("tenpoCd", response.data.tenpoCd ?? "");
      methods.setValue("tokuibunCd1", response.data.tokuibunCd1 ?? "");
      methods.setValue("tokuibunCd2", response.data.tokuibunCd2 ?? "");
      methods.setValue("tokuibunCd3", response.data.tokuibunCd3 ?? "");
      methods.setValue("tokuibunCd4", response.data.tokuibunCd4 ?? "");
      methods.setValue("tokuibunCd5", response.data.tokuibunCd5 ?? "");
      methods.setValue("version", response.data.version ?? "");

      // コードに紐づく名称、端数位置の設定
      B100060HandleSetNmAndHasuichi(methods, navigate, setMsg);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNm1", "");
      methods.setValue("tokuiNm2", "");
      methods.setValue("tokuiKana", "");
      methods.setValue("tokuiNmr", "");
      methods.setValue("shokuchiKbn", null);
      methods.setValue("postCd", "");
      methods.setValue("address1", "");
      methods.setValue("address2", "");
      methods.setValue("telNo", "");
      methods.setValue("faxNo", "");
      methods.setValue("shokaKbn", null);
      methods.setValue("itakusokoCd", "");
      methods.setValue("sokoNm", "");
      methods.setValue("tokuiKbn", null);
      methods.setValue("seikyuKbn", null);
      methods.setValue("seikyuCd", "");
      methods.setValue("seikyushitenCd", "");
      methods.setValue("urikakeKbn", null);
      methods.setValue("urikakeCd", "");
      methods.setValue("urikakeshitenCd", "");
      methods.setValue("nonyuKbn", null);
      methods.setValue("unsogaishaCd", "");
      methods.setValue("unsogaishaNm", "");
      methods.setValue("shainCd", "");
      methods.setValue("shainNm", "");
      methods.setValue("bumonNm", "");
      methods.setValue("urikakeshainCd", "");
      methods.setValue("urikakeshainNm", "");
      methods.setValue("urikakebumonNm", "");
      methods.setValue("torihikikaishiYmd", "");
      methods.setValue("torihikishuryoYmd", "");
      methods.setValue("shimeD", "");
      methods.setValue("kaishuyoteiM", null);
      methods.setValue("kaishuyoteiD", "");
      methods.setValue("kaishuKbn", "");
      methods.setValue("seikyushoKbn", null);
      methods.setValue("seikyushokeishikiKbn", null);
      methods.setValue("seikyushosaibanKbn", null);
      methods.setValue("seikyushoNo", null);
      methods.setValue("denpyogyosu", "");
      methods.setValue("denpyoshubetsuCd", "");
      methods.setValue("denpyoshubetsuNm", "");
      methods.setValue("denpyoKbn", "");
      methods.setValue("tenpudenpyoCd", "");
      methods.setValue("tenpudenpyoNm", "");
      methods.setValue("ritsu", "");
      methods.setValue("bunrui", "");
      methods.setValue("shutsuryokushohinCd", null);
      methods.setValue("torihikisakiCd", "");
      methods.setValue("hyakatenCd", "");
      methods.setValue("shatenCd", "");
      methods.setValue("kinmarumeKbn", null);
      methods.setValue("zeimarumeKbn", null);
      methods.setValue("zeiKbn", null);
      methods.setValue("tankamarumeKbn", null);
      methods.setValue("tankahasuichiKbn", null);
      methods.setValue("tankahasuichi", "");
      methods.setValue("tankaKakeritsu", "");
      methods.setValue("jodaihyojiKbn", null);
      methods.setValue("sakujoyoteiKbn", null);
      methods.setValue("kyakusakinoKbn", null);
      methods.setValue("kigyoCd", "");
      methods.setValue("tenpoCd", "");
      methods.setValue("tokuibunCd1", "");
      methods.setValue("tokuibunNm1", "");
      methods.setValue("tokuibunCd2", "");
      methods.setValue("tokuibunNm2", "");
      methods.setValue("tokuibunCd3", "");
      methods.setValue("tokuibunNm3", "");
      methods.setValue("tokuibunCd4", "");
      methods.setValue("tokuibunNm4", "");
      methods.setValue("tokuibunCd5", "");
      methods.setValue("tokuibunNm5", "");
      methods.setValue("version", "");
    });
};

// 参照得意先情報表示処理
export const B100060SanshoTokui = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 変更されていない場合は切替しない
  if (
    !methods.getFieldState("sanshoTokuiCd").isDirty &&
    !methods.getFieldState("sanshoTokuishitenCd").isDirty
  ) {
    return;
  }

  const data = methods.getValues();
  if (data.sanshoTokuiCd === "" || data.sanshoTokuishitenCd === "") {
    methods.setValue("tokuiNm1", "");
    methods.setValue("tokuiNm2", "");
    methods.setValue("tokuiKana", "");
    methods.setValue("tokuiNmr", "");
    methods.setValue("shokuchiKbn", null);
    methods.setValue("postCd", "");
    methods.setValue("address1", "");
    methods.setValue("address2", "");
    methods.setValue("telNo", "");
    methods.setValue("faxNo", "");
    methods.setValue("shokaKbn", null);
    methods.setValue("itakusokoCd", "");
    methods.setValue("sokoNm", "");
    methods.setValue("tokuiKbn", null);
    methods.setValue("seikyuKbn", null);
    methods.setValue("seikyuCd", "");
    methods.setValue("seikyushitenCd", "");
    methods.setValue("urikakeKbn", null);
    methods.setValue("urikakeCd", "");
    methods.setValue("urikakeshitenCd", "");
    methods.setValue("nonyuKbn", null);
    methods.setValue("unsogaishaCd", "");
    methods.setValue("unsogaishaNm", "");
    methods.setValue("shainCd", "");
    methods.setValue("shainNm", "");
    methods.setValue("bumonCd", "");
    methods.setValue("bumonNm", "");
    methods.setValue("urikakeshainCd", "");
    methods.setValue("urikakeshainNm", "");
    methods.setValue("urikakebumonCd", "");
    methods.setValue("urikakebumonNm", "");
    methods.setValue("torihikikaishiYmd", "");
    methods.setValue("torihikishuryoYmd", "");
    methods.setValue("shimeD", "");
    methods.setValue("kaishuyoteiM", null);
    methods.setValue("kaishuyoteiD", "");
    methods.setValue("kaishuKbn", "");
    methods.setValue("seikyushoKbn", null);
    methods.setValue("seikyushokeishikiKbn", null);
    methods.setValue("seikyushosaibanKbn", null);
    methods.setValue("seikyushoNo", null);
    methods.setValue("denpyogyosu", "");
    methods.setValue("denpyoshubetsuCd", "");
    methods.setValue("denpyoshubetsuNm", "");
    methods.setValue("denpyoKbn", "");
    methods.setValue("tenpudenpyoCd", "");
    methods.setValue("tenpudenpyoNm", "");
    methods.setValue("ritsu", "");
    methods.setValue("bunrui", "");
    methods.setValue("shutsuryokushohinCd", null);
    methods.setValue("torihikisakiCd", "");
    methods.setValue("hyakatenCd", "");
    methods.setValue("shatenCd", "");
    methods.setValue("kinmarumeKbn", null);
    methods.setValue("zeimarumeKbn", null);
    methods.setValue("zeiKbn", null);
    methods.setValue("tankamarumeKbn", null);
    methods.setValue("tankahasuichiKbn", null);
    methods.setValue("tankahasuichi", "");
    methods.setValue("tankaKakeritsu", "");
    methods.setValue("jodaihyojiKbn", null);
    methods.setValue("sakujoyoteiKbn", null);
    methods.setValue("kyakusakinoKbn", null);
    methods.setValue("kigyoCd", "");
    methods.setValue("tenpoCd", "");
    methods.setValue("tokuibunCd1", "");
    methods.setValue("tokuibunNm1", "");
    methods.setValue("tokuibunCd2", "");
    methods.setValue("tokuibunNm2", "");
    methods.setValue("tokuibunCd3", "");
    methods.setValue("tokuibunNm3", "");
    methods.setValue("tokuibunCd4", "");
    methods.setValue("tokuibunNm4", "");
    methods.setValue("tokuibunCd5", "");
    methods.setValue("tokuibunNm5", "");
    return;
  }
  await B100060Get({
    tokuiCd: data.sanshoTokuiCd,
    tokuishitenCd: data.sanshoTokuishitenCd,
  })
    .then((response) => {
      methods.setValue("tokuiNm1", response.data.tokuiNm1 ?? "");
      methods.setValue("tokuiNm2", response.data.tokuiNm2 ?? "");
      methods.setValue("tokuiKana", response.data.tokuiKana ?? "");
      methods.setValue("tokuiNmr", response.data.tokuiNmr ?? "");
      methods.setValue(
        "shokuchiKbn",
        getSCode(ShokuchiKbn, response.data.shokuchiKbn) ?? null
      );
      methods.setValue("postCd", response.data.postCd ?? "");
      methods.setValue("address1", response.data.address1 ?? "");
      methods.setValue("address2", response.data.address2 ?? "");
      methods.setValue("telNo", response.data.telNo ?? "");
      methods.setValue("faxNo", response.data.faxNo ?? "");
      methods.setValue(
        "shokaKbn",
        getSCode(B100ShokaKbn, response.data.shokaKbn) ?? null
      );
      methods.setValue("itakusokoCd", response.data.itakusokoCd ?? "");
      methods.setValue(
        "tokuiKbn",
        getSCode(TokuiKbn, response.data.tokuiKbn) ?? null
      );
      methods.setValue(
        "seikyuKbn",
        getSCode(SeikyuKbn, response.data.seikyuKbn) ?? null
      );
      methods.setValue("seikyuCd", methods.getValues().seikyuCd ?? "");
      methods.setValue(
        "seikyushitenCd",
        methods.getValues().seikyushitenCd ?? ""
      );
      methods.setValue(
        "urikakeKbn",
        getSCode(UrikakeKbn, response.data.urikakeKbn) ?? null
      );
      methods.setValue("urikakeCd", methods.getValues().urikakeCd ?? "");
      methods.setValue(
        "urikakeshitenCd",
        methods.getValues().urikakeshitenCd ?? ""
      );
      methods.setValue(
        "nonyuKbn",
        getSCode(NonyuKbn, response.data.nonyuKbn) ?? null
      );
      methods.setValue("unsogaishaCd", response.data.unsogaishaCd ?? "");
      methods.setValue("shainCd", response.data.shainCd ?? "");
      methods.setValue("urikakeshainCd", response.data.urikakeshainCd ?? "");
      methods.setValue(
        "torihikikaishiYmd",
        response.data.torihikikaishiYmd ?? ""
      );
      methods.setValue(
        "torihikishuryoYmd",
        response.data.torihikishuryoYmd ?? ""
      );
      methods.setValue("shimeD", response.data.shimeD ?? "");
      methods.setValue(
        "kaishuyoteiM",
        getSCode(KaishuyoteiM, response.data.kaishuyoteiM) ?? null
      );
      methods.setValue("kaishuyoteiD", response.data.kaishuyoteiD ?? "");
      methods.setValue(
        "kaishuKbn",
        getSCode(KaishuKbn, response.data.kaishuKbn) ?? null
      );
      methods.setValue(
        "seikyushoKbn",
        getSCode(SeikyushoKbn, response.data.seikyushoKbn) ?? null
      );
      methods.setValue(
        "seikyushokeishikiKbn",
        getSCode(SeikyushokeishikiKbn, response.data.seikyushokeishikiKbn) ??
          null
      );
      methods.setValue(
        "seikyushosaibanKbn",
        getSCode(SeikyushosaibanKbn, response.data.seikyushosaibanKbn) ?? null
      );
      methods.setValue("seikyushoNo", response.data.seikyushoNo ?? "");
      methods.setValue("denpyogyosu", response.data.denpyogyosu ?? "");
      methods.setValue(
        "denpyoshubetsuCd",
        response.data.denpyoshubetsuCd ?? ""
      );
      methods.setValue("denpyoKbn", response.data.denpyoKbn ?? "");
      methods.setValue("tenpudenpyoCd", response.data.tenpudenpyoCd ?? "");
      methods.setValue("ritsu", response.data.ritsu ?? "");
      methods.setValue("bunrui", response.data.bunrui ?? "");
      methods.setValue(
        "shutsuryokushohinCd",
        getSCode(ShutsuryokushohinCd, response.data.shutsuryokushohinCd) ?? null
      );
      methods.setValue("torihikisakiCd", response.data.torihikisakiCd ?? "");
      methods.setValue("hyakatenCd", response.data.hyakatenCd ?? "");
      methods.setValue("shatenCd", response.data.shatenCd ?? "");
      methods.setValue(
        "kinmarumeKbn",
        getSCode(KinmaremeKbn, response.data.kinmarumeKbn) ?? null
      );
      methods.setValue(
        "zeimarumeKbn",
        getSCode(ZeimarumeKbn, response.data.zeimarumeKbn) ?? null
      );
      methods.setValue(
        "zeiKbn",
        getSCode(ZeiKbn, response.data.zeiKbn) ?? null
      );
      methods.setValue(
        "tankamarumeKbn",
        getSCode(TankamarumeKbn, response.data.tankamarumeKbn) ?? null
      );
      methods.setValue(
        "tankahasuichiKbn",
        getSCode(TankamarumeKbn, response.data.tankahasuichiKbn) ?? null
      );
      methods.setValue("tankahasuichi", response.data.tankahasuichi ?? "");
      methods.setValue("tankaKakeritsu", response.data.tankaKakeritsu ?? "");
      methods.setValue(
        "jodaihyojiKbn",
        getSCode(JodaihyojiKbn, response.data.jodaihyojiKbn) ?? null
      );
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn) ?? null
      );
      methods.setValue(
        "kyakusakinoKbn",
        getSCode(KyakusakinoKbn, response.data.kyakusakinoKbn) ?? null
      );
      methods.setValue("kigyoCd", response.data.kigyoCd ?? "");
      methods.setValue("tenpoCd", response.data.tenpoCd ?? "");
      methods.setValue("tokuibunCd1", response.data.tokuibunCd1 ?? "");
      methods.setValue("tokuibunCd2", response.data.tokuibunCd2 ?? "");
      methods.setValue("tokuibunCd3", response.data.tokuibunCd3 ?? "");
      methods.setValue("tokuibunCd4", response.data.tokuibunCd4 ?? "");
      methods.setValue("tokuibunCd5", response.data.tokuibunCd5 ?? "");

      // 値を保持
      methods.unregister("sanshoTokuiCd", { keepValue: true });
      methods.unregister("sanshoTokuishitenCd", { keepValue: true });

      // コードに紐づく名称、端数位置の設定
      B100060HandleSetNmAndHasuichi(methods, navigate, setMsg);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNm1", "");
      methods.setValue("tokuiNm2", "");
      methods.setValue("tokuiKana", "");
      methods.setValue("tokuiNmr", "");
      methods.setValue("shokuchiKbn", null);
      methods.setValue("postCd", "");
      methods.setValue("address1", "");
      methods.setValue("address2", "");
      methods.setValue("telNo", "");
      methods.setValue("faxNo", "");
      methods.setValue("shokaKbn", null);
      methods.setValue("itakusokoCd", "");
      methods.setValue("sokoNm", "");
      methods.setValue("tokuiKbn", null);
      methods.setValue("seikyuKbn", null);
      methods.setValue("seikyuCd", "");
      methods.setValue("seikyushitenCd", "");
      methods.setValue("urikakeKbn", null);
      methods.setValue("urikakeCd", "");
      methods.setValue("urikakeshitenCd", "");
      methods.setValue("nonyuKbn", null);
      methods.setValue("unsogaishaCd", "");
      methods.setValue("unsogaishaNm", "");
      methods.setValue("shainCd", "");
      methods.setValue("shainNm", "");
      methods.setValue("bumonNm", "");
      methods.setValue("urikakeshainCd", "");
      methods.setValue("urikakeshainNm", "");
      methods.setValue("urikakebumonNm", "");
      methods.setValue("torihikikaishiYmd", "");
      methods.setValue("torihikishuryoYmd", "");
      methods.setValue("shimeD", "");
      methods.setValue("kaishuyoteiM", null);
      methods.setValue("kaishuyoteiD", "");
      methods.setValue("kaishuKbn", "");
      methods.setValue("seikyushoKbn", null);
      methods.setValue("seikyushokeishikiKbn", null);
      methods.setValue("seikyushosaibanKbn", null);
      methods.setValue("seikyushoNo", null);
      methods.setValue("denpyogyosu", "");
      methods.setValue("denpyoshubetsuCd", "");
      methods.setValue("denpyoshubetsuNm", "");
      methods.setValue("denpyoKbn", "");
      methods.setValue("tenpudenpyoCd", "");
      methods.setValue("tenpudenpyoNm", "");
      methods.setValue("ritsu", "");
      methods.setValue("bunrui", "");
      methods.setValue("shutsuryokushohinCd", null);
      methods.setValue("torihikisakiCd", "");
      methods.setValue("hyakatenCd", "");
      methods.setValue("shatenCd", "");
      methods.setValue("kinmarumeKbn", null);
      methods.setValue("zeimarumeKbn", null);
      methods.setValue("zeiKbn", null);
      methods.setValue("tankamarumeKbn", null);
      methods.setValue("tankahasuichiKbn", null);
      methods.setValue("tankahasuichi", "");
      methods.setValue("tankaKakeritsu", "");
      methods.setValue("jodaihyojiKbn", null);
      methods.setValue("sakujoyoteiKbn", null);
      methods.setValue("kyakusakinoKbn", null);
      methods.setValue("kigyoCd", "");
      methods.setValue("tenpoCd", "");
      methods.setValue("tokuibunCd1", "");
      methods.setValue("tokuibunNm1", "");
      methods.setValue("tokuibunCd2", "");
      methods.setValue("tokuibunNm2", "");
      methods.setValue("tokuibunCd3", "");
      methods.setValue("tokuibunNm3", "");
      methods.setValue("tokuibunCd4", "");
      methods.setValue("tokuibunNm4", "");
      methods.setValue("tokuibunCd5", "");
      methods.setValue("tokuibunNm5", "");
    });
};

// コードに紐づく名称、端数位置の設定
export const B100060HandleSetNmAndHasuichi = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 委託倉庫名を取得
  B000190ItakusokoNmr(methods, navigate, setMsg);
  // 運送会社名を取得
  B000111UnsogaishaNm(methods, navigate, setMsg);

  // 同期させる
  (async () => {
    // 担当者名を取得
    await B000140ShainNmBumonCd(methods, navigate, setMsg);
    // 担当部門名を取得
    await B000130BumonNm(methods, navigate, setMsg);
    // 売掛担当者名を取得
    await B000140UrikakeshainNmBumonCd(methods, navigate, setMsg);
    // 売掛担当部門名を取得
    await B000130UrikakebumonNm(methods, navigate, setMsg);
  })();

  // 伝票種別名を取得
  B000111DenpyoshubetsuNm(methods, navigate, setMsg);
  // 添付伝票名を取得
  B000111TenpudenpyoNm(methods, navigate, setMsg);
  // 得意先分類 1 名を取得
  B000111TokuibunNm1(methods, navigate, setMsg);
  // 得意先分類 2 名を取得
  B000111TokuibunNm2(methods, navigate, setMsg);
  // 得意先分類 3 名を取得
  B000111TokuibunNm3(methods, navigate, setMsg);
  // 得意先分類 4 名を取得
  B000111TokuibunNm4(methods, navigate, setMsg);
  // 得意先分類 5 名を取得
  B000111TokuibunNm5(methods, navigate, setMsg);
  // 単価端数位置の設定
  if (Number(methods.getValues().tankahasuichi) < 0) {
    methods.setValue("tankahasuichiKbn", getSCode(B100060Tankahasuichi, "0"));
  } else {
    methods.setValue("tankahasuichiKbn", getSCode(B100060Tankahasuichi, "1"));
  }
  methods.setValue(
    "tankahasuichi",
    Math.abs(Number(methods.getValues().tankahasuichi))
  );
};

//得意先名(From)取得メソッド
export const B100060TokuiNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCdFrom === "" || data.tokuishitenCdFrom === "") {
    methods.setValue("tokuiNmFrom", "");
    return;
  }
  await B100060Get({
    tokuiCd: data.tokuiCdFrom,
    tokuishitenCd: data.tokuishitenCdFrom,
  })
    .then((response) => {
      methods.setValue("tokuiNmFrom", response.data.tokuiNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNmFrom", "");
    });
};

//得意先名(To)取得メソッド
export const B100060TokuiNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.tokuiCdTo === "" || data.tokuishitenCdTo === "") {
    methods.setValue("tokuiNmTo", "");
    return;
  }
  await B100060Get({
    tokuiCd: data.tokuiCdTo,
    tokuishitenCd: data.tokuishitenCdTo,
  })
    .then((response) => {
      methods.setValue("tokuiNmTo", response.data.tokuiNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNmTo", "");
    });
};
